export const aboutInfo = {
  brandName: '鲍鱼网址域名导航',
  slogan: '安全访问，从正确域名开始',
  introduction: `鲍鱼网址域名导航平台成立于2020年，是鲍鱼平台官方授权的域名入口导航服务。我们致力于为广大用户提供最新、最准确的鲍鱼官方域名入口信息，帮助用户安全、便捷地访问鲍鱼平台。

多年来，我们始终坚持以用户安全为核心，建立了完善的域名监控和更新机制。每当鲍鱼平台域名发生变化时，我们会在第一时间更新信息并通过多渠道通知用户，确保用户不会因域名失效而无法访问平台。

我们的团队由资深网络安全专家和用户体验设计师组成，专注于域名安全、防钓鱼技术研究和用户教育。通过持续的技术创新和内容优化，我们已累计服务超过百万用户，获得了广泛的好评和信赖。`,
  reputation: [
    { label: '服务用户', value: '1,000,000+' },
    { label: '域名更新响应', value: '实时同步' },
    { label: '用户满意度', value: '99.2%' },
    { label: '安全运营天数', value: '2,100+' },
  ],
  contact: {
    email: 'support@baoyu-official.com',
    wechat: 'baoyu-kefu',
    qq: '800123456',
    workingHours: '周一至周日 9:00 - 21:00',
  },
};